/*eslint-disable */

import appFooter from '@/components/public/common/footer/';
import toast from '@/services/toast';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';

var $ = window.jQuery = require('jquery');
export default {
  name: 'password-reset',
  components: {
    'app-footer': appFooter,
  },
  props: [],
  data() {
    return {
      password: '',
      confirm_password: '',
      id: '',
      submitted: false,
      imageIndex:'',
      has_number:false,
      has_lowercase:false,
      has_uppercase:false,
      has_special:false,
      phoneNumberBlurState:false
    }
  },
  computed: {

  },
  mounted() {
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
    this.randomImgLoaded();
  },
  methods: {
    passwordValidatorMethod(){
        this.has_number = /\d/.test(this.password);
        this.has_lowercase = /[a-z]/.test(this.password);
        this.has_uppercase = /[A-Z]/.test(this.password);
        this.has_special = /[#?!@$%^&*-]/.test(this.password);
        this.password = this.password.replace(/\s/g,'')
    },
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('random_bgimg');
      if (x < images.length) {
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        setTimeout(() => {
          this.preloader = false;
          $('.app-loader').hide()
        }, 1500);
      }
    },
    validateBeforeResetPasswordSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            password: this.password,
            confirm_password: this.confirm_password
          }
          this.$store.dispatch('resetPasswordConfirmFun', {
              data: {
                data: data,
                id: this.$route.params.reset_key
              }
            })
            .then((response) => {
              if (response.status == 200) {
                toast.success(response.data.msg);
                this.password = ''
                this.confirm_password = ''
                this.$validator.reset();
                this.has_number = false
                this.has_lowercase = false
                this.has_uppercase = false
                this.has_special = false
              }
            }).catch((err) => {
              this.password = ''
              this.confirm_password = ''
              this.$validator.reset();
              this.has_number = false
              this.has_lowercase = false
              this.has_uppercase = false
              this.has_special = false
              toast.error('Link is expired');
            })
          return
        }
      })
    }
  },
  beforeCreate: function() {
    $('body').addClass('public-routes');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('public-routes');
    next();
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
  },
}